'use strict';

/** Classic document-level types used by the `type` field on every workpackage document. */
module.exports = {
  master: 'master',
  workpackage: 'workpackage',
};
